import posthog from 'posthog-js'


const API_KEY = process.env.REACT_APP_POSTHOG_API_KEY || ""
const API_HOST = process.env.REACT_APP_POSTHOG_API_HOST || ""



// Initialize PostHog
posthog.init(API_KEY, {
    api_host: API_HOST, // or your self-hosted domain
    autocapture: true, // automatically captures clicks, pageviews, etc.
    capture_pageview: true,
    person_profiles: "always",
    defaults: "2025-05-24",
    loaded: () => {
        console.log('✅ PostHog is loaded')
    },
})



export default posthog